module.exports = __webpack_public_path__ + "media/media/product-card/video_prev-big-a2f1e4262939cb9b0f8e01fca3ef47d8.jpg";